import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./box-plus.svg?react";

export const BoxPlusIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
